"use strict";

var _slicedToArray = require("/codebuild/output/src507705591/src/boonkbots/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _toConsumableArray = require("/codebuild/output/src507705591/src/boonkbots/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/codebuild/output/src507705591/src/boonkbots/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src507705591/src/boonkbots/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/codebuild/output/src507705591/src/boonkbots/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/codebuild/output/src507705591/src/boonkbots/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/codebuild/output/src507705591/src/boonkbots/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MerkleMountainRange = void 0;

var buffer_1 = require("buffer");

var sha256_1 = __importDefault(require("crypto-js/sha256"));

var Base_1 = __importDefault(require("./Base")); // @credit: https://github.com/wanseob/solidity-mmr

/**
 * @desc The index of this MMR implementation starts from 1 not 0.
 */


var MerkleMountainRange =
/*#__PURE__*/
function (_Base_1$default) {
  _inherits(MerkleMountainRange, _Base_1$default);

  function MerkleMountainRange() {
    var _this;

    var hashFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : sha256_1.default;
    var leaves = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var hashLeafFn = arguments.length > 2 ? arguments[2] : undefined;
    var peakBaggingFn = arguments.length > 3 ? arguments[3] : undefined;
    var hashBranchFn = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, MerkleMountainRange);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MerkleMountainRange).call(this));
    _this.root = buffer_1.Buffer.alloc(0);
    _this.size = 0;
    _this.width = 0;
    _this.hashes = {};
    _this.data = {};
    leaves = leaves.map(_this.bufferify);
    _this.hashFn = _this.bufferifyFn(hashFn);
    _this.hashLeafFn = hashLeafFn;
    _this.peakBaggingFn = peakBaggingFn;
    _this.hashBranchFn = hashBranchFn;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = leaves[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var leaf = _step.value;

        _this.append(leaf);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return _this;
  }
  /**
   * @desc This only stores the hashed value of the leaf.
   * If you need to retrieve the detail data later, use a map to store them.
   */


  _createClass(MerkleMountainRange, [{
    key: "append",
    value: function append(data) {
      data = this.bufferify(data);
      var dataHash = this.hashFn(data);
      var dataHashHex = this.bufferToHex(dataHash);

      if (!this.data[dataHashHex] || this.bufferToHex(this.hashFn(this.data[dataHashHex])) !== dataHashHex) {
        this.data[dataHashHex] = data;
      }

      var leaf = this.hashLeaf(this.size + 1, dataHash);
      this.hashes[this.size + 1] = leaf;
      this.width += 1; // find peaks for enlarged tree

      var peakIndexes = this.getPeakIndexes(this.width); // the right most peak's value is the new size of the updated tree

      this.size = this.getSize(this.width); // starting from the left-most peak, get all peak hashes

      var peaks = [];

      for (var i = 0; i < peakIndexes.length; i++) {
        peaks[i] = this._getOrCreateNode(peakIndexes[i]);
      } // update the tree root hash


      this.root = this.peakBagging(this.width, peaks);
    }
    /**
     * @desc It returns the hash of a leaf node with hash(M | DATA )
     *       M is the index of the node.
     */

  }, {
    key: "hashLeaf",
    value: function hashLeaf(index, dataHash) {
      dataHash = this.bufferify(dataHash);

      if (this.hashLeafFn) {
        return this.bufferify(this.hashLeafFn(index, dataHash));
      }

      return this.hashFn(buffer_1.Buffer.concat([this.bufferify(index), dataHash]));
    }
    /**
     * @desc It returns the hash a parent node with hash(M | Left child | Right child)
     *       M is the index of the node.
     */

  }, {
    key: "hashBranch",
    value: function hashBranch(index, left, right) {
      if (this.hashBranchFn) {
        return this.bufferify(this.hashBranchFn(index, left, right));
      }

      return this.hashFn(buffer_1.Buffer.concat([this.bufferify(index), this.bufferify(left), this.bufferify(right)]));
    }
  }, {
    key: "getPeaks",
    value: function getPeaks() {
      var peakIndexes = this.getPeakIndexes(this.width);
      var peaks = [];

      for (var i = 0; i < peakIndexes.length; i++) {
        peaks[i] = this.hashes[peakIndexes[i]];
      }

      return peaks;
    }
  }, {
    key: "getLeafIndex",
    value: function getLeafIndex(width) {
      if (width % 2 === 1) {
        return this.getSize(width);
      }

      return this.getSize(width - 1) + 1;
    }
    /**
     * @desc It returns all peaks of the smallest merkle mountain range tree which includes
     *       the given index(size).
     */

  }, {
    key: "getPeakIndexes",
    value: function getPeakIndexes(width) {
      var numPeaks = this.numOfPeaks(width);
      var peakIndexes = [];
      var count = 0;
      var size = 0;

      for (var i = 255; i > 0; i--) {
        if ((width & 1 << i - 1) !== 0) {
          // peak exists
          size = size + (1 << i) - 1;
          peakIndexes[count++] = size;

          if (peakIndexes.length >= numPeaks) {
            break;
          }
        }
      }

      if (count !== peakIndexes.length) {
        throw new Error('invalid bit calculation');
      }

      return peakIndexes;
    }
  }, {
    key: "numOfPeaks",
    value: function numOfPeaks(width) {
      var bits = width;
      var num = 0;

      while (bits > 0) {
        if (bits % 2 === 1) {
          num++;
        }

        bits = bits >> 1;
      }

      return num;
    }
  }, {
    key: "peakBagging",
    value: function peakBagging(width, peaks) {
      var size = this.getSize(width);

      if (this.numOfPeaks(width) !== peaks.length) {
        throw new Error('received invalid number of peaks');
      }

      if (width === 0 && !peaks.length) {
        return buffer_1.Buffer.alloc(0);
      }

      if (this.peakBaggingFn) {
        return this.bufferify(this.peakBaggingFn(size, peaks));
      }

      return this.hashFn(buffer_1.Buffer.concat([this.bufferify(size)].concat(_toConsumableArray(peaks.map(this.bufferify)))));
    }
    /**
     * @desc It returns the size of the tree.
     */

  }, {
    key: "getSize",
    value: function getSize(width) {
      return (width << 1) - this.numOfPeaks(width);
    }
    /**
     * @desc It returns the root value of the tree.
     */

  }, {
    key: "getRoot",
    value: function getRoot() {
      return this.root;
    }
  }, {
    key: "getHexRoot",
    value: function getHexRoot() {
      return this.bufferToHex(this.getRoot());
    }
    /**
     * @dev It returns the hash value of a node for the given position. Note that the index starts from 1.
     */

  }, {
    key: "getNode",
    value: function getNode(index) {
      return this.hashes[index];
    }
    /**
     * @desc It returns the height of the highest peak.
     */

  }, {
    key: "mountainHeight",
    value: function mountainHeight(size) {
      var height = 1;

      while (1 << height <= size + height) {
        height++;
      }

      return height - 1;
    }
    /**
     * @desc It returns the height of the index.
     */

  }, {
    key: "heightAt",
    value: function heightAt(index) {
      var reducedIndex = index;
      var peakIndex = 0;
      var height = 0; // if an index has a left mountain then subtract the mountain

      while (reducedIndex > peakIndex) {
        reducedIndex -= (1 << height) - 1;
        height = this.mountainHeight(reducedIndex);
        peakIndex = (1 << height) - 1;
      } // index is on the right slope


      return height - (peakIndex - reducedIndex);
    }
    /**
     * @desc It returns whether the index is the leaf node or not
     */

  }, {
    key: "isLeaf",
    value: function isLeaf(index) {
      return this.heightAt(index) === 1;
    }
    /**
     * @desc It returns the children when it is a parent node.
     */

  }, {
    key: "getChildren",
    value: function getChildren(index) {
      var left = index - (1 << this.heightAt(index) - 1);
      var right = index - 1;

      if (left === right) {
        throw new Error('not a parent');
      }

      return [left, right];
    }
    /**
     * @desc It returns a merkle proof for a leaf. Note that the index starts from 1.
     */

  }, {
    key: "getMerkleProof",
    value: function getMerkleProof(index) {
      if (index > this.size) {
        throw new Error('out of range');
      }

      if (!this.isLeaf(index)) {
        throw new Error('not a leaf');
      }

      var root = this.root;
      var width = this.width; // find all peaks for bagging

      var peaks = this.getPeakIndexes(this.width);
      var peakBagging = [];
      var cursor = 0;

      for (var i = 0; i < peaks.length; i++) {
        // collect the hash of all peaks
        peakBagging[i] = this.hashes[peaks[i]]; // find the peak which includes the target index

        if (peaks[i] >= index && cursor === 0) {
          cursor = peaks[i];
        }
      }

      var left = 0;
      var right = 0; // get hashes of the siblings in the mountain which the index belgons to.
      // it moves the cursor from the summit of the mountain down to the target index

      var height = this.heightAt(cursor);
      var siblings = [];

      while (cursor !== index) {
        height--;

        var _this$getChildren = this.getChildren(cursor);

        var _this$getChildren2 = _slicedToArray(_this$getChildren, 2);

        left = _this$getChildren2[0];
        right = _this$getChildren2[1];
        // move the cursor down to the left size or right size
        cursor = index <= left ? left : right; // remaining node is the sibling

        siblings[height - 1] = this.hashes[index <= left ? right : left];
      }

      return {
        root: root,
        width: width,
        peakBagging: peakBagging,
        siblings: siblings
      };
    }
    /**
     * @desc It returns true when the given params verifies that the given value exists in the tree or reverts the transaction.
     */

  }, {
    key: "verify",
    value: function verify(root, width, index, value, peaks, siblings) {
      value = this.bufferify(value);
      var size = this.getSize(width);

      if (size < index) {
        throw new Error('index is out of range');
      } // check the root equals the peak bagging hash


      if (!root.equals(this.peakBagging(width, peaks))) {
        throw new Error('invalid root hash from the peaks');
      } // find the mountain where the target index belongs to


      var cursor = 0;
      var targetPeak;
      var peakIndexes = this.getPeakIndexes(width);

      for (var i = 0; i < peakIndexes.length; i++) {
        if (peakIndexes[i] >= index) {
          targetPeak = peaks[i];
          cursor = peakIndexes[i];
          break;
        }
      }

      if (!targetPeak) {
        throw new Error('target not found');
      } // find the path climbing down


      var height = siblings.length + 1;
      var path = new Array(height);
      var left = 0;
      var right = 0;

      while (height > 0) {
        // record the current cursor and climb down
        path[--height] = cursor;

        if (cursor === index) {
          // on the leaf node. Stop climbing down
          break;
        } else {
          // on the parent node. Go left or right
          var _this$getChildren3 = this.getChildren(cursor);

          var _this$getChildren4 = _slicedToArray(_this$getChildren3, 2);

          left = _this$getChildren4[0];
          right = _this$getChildren4[1];
          cursor = index > left ? right : left;
          continue;
        }
      } // calculate the summit hash climbing up again


      var node;

      while (height < path.length) {
        // move cursor
        cursor = path[height];

        if (height === 0) {
          // cusor is on the leaf
          node = this.hashLeaf(cursor, this.hashFn(value));
        } else if (cursor - 1 === path[height - 1]) {
          // cursor is on a parent and a siblings is on the left
          node = this.hashBranch(cursor, siblings[height - 1], node);
        } else {
          // cursor is on a parent and a siblings is on the right
          node = this.hashBranch(cursor, node, siblings[height - 1]);
        } // climb up


        height++;
      } // computed hash value of the summit should equal to the target peak hash


      if (!node.equals(targetPeak)) {
        throw new Error('hashed peak is invalid');
      }

      return true;
    }
  }, {
    key: "peaksToPeakMap",
    value: function peaksToPeakMap(width, peaks) {
      var peakMap = {};
      var bitIndex = 0;
      var peakRef = 0;
      var count = peaks.length;

      for (var height = 1; height <= 32; height++) {
        // index starts from the right most bit
        bitIndex = 32 - height;
        peakRef = 1 << height - 1;

        if ((width & peakRef) !== 0) {
          peakMap[bitIndex] = peaks[--count];
        } else {
          peakMap[bitIndex] = 0;
        }
      }

      if (count !== 0) {
        throw new Error('invalid number of peaks');
      }

      return peakMap;
    }
  }, {
    key: "peakMapToPeaks",
    value: function peakMapToPeaks(width, peakMap) {
      var arrLength = this.numOfPeaks(width);
      var peaks = new Array(arrLength);
      var count = 0;

      for (var i = 0; i < 32; i++) {
        if (peakMap[i] !== 0) {
          peaks[count++] = peakMap[i];
        }
      }

      if (count !== arrLength) {
        throw new Error('invalid number of peaks');
      }

      return peaks;
    }
  }, {
    key: "peakUpdate",
    value: function peakUpdate(width, prevPeakMap, itemHash) {
      var nextPeakMap = {};
      var newWidth = width + 1;
      var cursorIndex = this.getLeafIndex(newWidth);
      var cursorNode = this.hashLeaf(cursorIndex, itemHash);
      var bitIndex = 0;
      var peakRef = 0;
      var prevPeakExist = false;
      var nextPeakExist = false;
      var obtained = false;

      for (var height = 1; height <= 32; height++) {
        // index starts from the right most bit
        bitIndex = 32 - height;

        if (obtained) {
          nextPeakMap[bitIndex] = prevPeakMap[bitIndex];
        } else {
          peakRef = 1 << height - 1;
          prevPeakExist = (width & peakRef) !== 0;
          nextPeakExist = (newWidth & peakRef) !== 0; // get new cursor node with hashing the peak and the current cursor

          cursorIndex++;

          if (prevPeakExist) {
            cursorNode = this.hashBranch(cursorIndex, prevPeakMap[bitIndex], cursorNode);
          } // if new peak exists for the bit index


          if (nextPeakExist) {
            // if prev peak exists for the bit index
            if (prevPeakExist) {
              nextPeakMap[bitIndex] = prevPeakMap[bitIndex];
            } else {
              nextPeakMap[bitIndex] = cursorNode;
            }

            obtained = true;
          } else {
            nextPeakMap[bitIndex] = 0;
          }
        }
      }

      return nextPeakMap;
    }
  }, {
    key: "rollUp",
    value: function rollUp(root, width, peaks, itemHashes) {
      // check the root equals the peak bagging hash
      if (!root.equals(this.peakBagging(width, peaks))) {
        throw new Error('invalid root hash from the peaks');
      }

      var tmpWidth = width;
      var tmpPeakMap = this.peaksToPeakMap(width, peaks);

      for (var i = 0; i < itemHashes.length; i++) {
        tmpPeakMap = this.peakUpdate(tmpWidth, tmpPeakMap, itemHashes[i]);
        tmpWidth++;
      }

      return this.peakBagging(tmpWidth, this.peakMapToPeaks(tmpWidth, tmpPeakMap));
    }
    /**
     * @desc It returns the hash value of the node for the index.
     *      If the hash already exists it simply returns the stored value. On the other hand,
     *      it computes hashes recursively downward.
     *      Only appending an item calls this function.
     */

  }, {
    key: "_getOrCreateNode",
    value: function _getOrCreateNode(index) {
      if (index > this.size) {
        throw new Error('out of range');
      }

      if (!this.hashes[index]) {
        var _this$getChildren5 = this.getChildren(index),
            _this$getChildren6 = _slicedToArray(_this$getChildren5, 2),
            leftIndex = _this$getChildren6[0],
            rightIndex = _this$getChildren6[1];

        var leftHash = this._getOrCreateNode(leftIndex);

        var rightHash = this._getOrCreateNode(rightIndex);

        this.hashes[index] = this.hashBranch(index, leftHash, rightHash);
      }

      return this.hashes[index];
    }
  }]);

  return MerkleMountainRange;
}(Base_1.default);

exports.MerkleMountainRange = MerkleMountainRange;
exports.default = MerkleMountainRange;